module.exports = __webpack_public_path__ + "static/media/7.b36a7fcc.png";